import { useEffect } from "react";

/**
 * Seo — sets document.title, meta description, and optional JSON-LD structured data.
 * `jsonLd` accepts a single object or array of objects; each is emitted as a
 * <script type="application/ld+json"> tag with a stable id so it can be replaced
 * without duplication as the user navigates between pages.
 */
export default function Seo({ title, description, jsonLd }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement("meta");
        m.setAttribute("name", "description");
        document.head.appendChild(m);
      }
      m.setAttribute("content", description);
    }

    const items = Array.isArray(jsonLd) ? jsonLd : (jsonLd ? [jsonLd] : []);
    const attached = [];
    items.forEach((data, idx) => {
      const id = `duemate-jsonld-${idx}`;
      let s = document.getElementById(id);
      if (!s) {
        s = document.createElement("script");
        s.type = "application/ld+json";
        s.id = id;
        document.head.appendChild(s);
      }
      s.textContent = JSON.stringify(data);
      attached.push(s);
    });
    return () => {
      // Only remove tags we own on unmount so different pages can inject their own
      attached.forEach((s) => { try { s.remove(); } catch {} });
    };
  }, [title, description, jsonLd]);
  return null;
}
